import React from 'react';
import { IconButton, Tooltip as MuiTooltip } from '@mui/material';
import { Error as ErrorIcon, Refresh as RefreshIcon } from '@mui/icons-material';

import s from './ErrorBanner.module.scss';

type Props = {
  message?: string;
  onRetry: () => void;
};

export const ErrorBanner = ({
  message = 'Failed to load logs. Please try again.',
  onRetry,
}: Props) => {
  return (
    <div className={s.errorBanner}>
      <div className={s.errorContent}>
        <ErrorIcon className={s.errorIcon} />
        <span className={s.errorMessage}>{message}</span>
        <MuiTooltip title="Retry" arrow placement="top">
          <IconButton onClick={onRetry} aria-label="Retry" size="small">
            <RefreshIcon />
          </IconButton>
        </MuiTooltip>
      </div>
    </div>
  );
};
